var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 11
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.795 5.503l3.628 3.875L12.59 1.21",
  stroke: "#06C167",
  strokeWidth: 2,
  fill: "none"
})));
export default SvgCheckmark;